import React, { useContext } from "react";
import './MoodSwitch.scss';
import { SettingsContext } from 'Providers/SettingsProvider';

function MoodSwitch() {
  const { mood, setAppState, t } = useContext(SettingsContext);
  const handleToggleMood=()=>{
    const moods=['bb','pv'];
    const idx=moods.indexOf(mood);
    const newIdx=(idx+1)%moods.length;
    setAppState(state=>{return {...state,mood:moods[newIdx]}});
  }
  return mood ? <div className={"mood-switch "+mood} onClick={handleToggleMood}>
    <div className="btn"></div>
    <div className="label">{t('mood')}</div>
  </div> : '';
}

export default MoodSwitch;
